<template>
  <v-card :class="`rounded-card card-shadow fill-height ${cardClass}`" width="100%">
    <v-tabs v-model="tab">
      <v-tab class="small-spacing">Local de Entrega</v-tab>
      <v-tab class="small-spacing">Local de Faturamento</v-tab>
      <v-tab class="small-spacing">Links</v-tab>
    </v-tabs>
    <v-divider/>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-compra-detalhes-comprador is-entrega :compra="compra"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-compra-detalhes-comprador :compra="compra"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-compra-d-etalhes-links :compra="compra"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import pxCompraDetalhesComprador from '@/modules/compra/detalhes/CompraDetalhesComprador.vue';
import pxCompraDEtalhesLinks from '@/modules/compra/detalhes/CompraDetalhesLinks.vue';

export default {
  props: {
    compra: Object,
    cardClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
  components: { pxCompraDetalhesComprador, pxCompraDEtalhesLinks },
};
</script>
